import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Blue_White_Gradient_Btn.css";

const Blue_White_Gradient_Btn = (props) => {
  return (
    <button
      className="Blue_White_Gradient_Btn"
      onClick={props?.onClick}
      type="button"
    >
      {props?.icon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={props?.icon} className="icon" />
        </div>
      )}
      <p className="btn_text">{props?.btn_name}</p>
    </button>
  );
};

export default Blue_White_Gradient_Btn;
